// extracted by mini-css-extract-plugin
export var TextColor = "shirt-collection-module--TextColor--VaH5f";
export var ZIndex = "shirt-collection-module--ZIndex--qIBU4";
export var fontSize = "shirt-collection-module--fontSize--6v3nP";
export var fontSizeText = "shirt-collection-module--fontSizeText--Sl0iv";
export var imageWidth = "shirt-collection-module--imageWidth--dBThe";
export var measureShirt = "shirt-collection-module--measureShirt--Sf6OW";
export var negativeMargin = "shirt-collection-module--negativeMargin--MtMSL";